import React from 'react';
import Input from './Input';
import Textarea from './Textarea';
import Select from './Select';
import RadioButton from './RadioButton';
import CheckboxGroup from './CheckboxGroup';
import Checkbox from './Checkbox';


function BiztranControlsFormik(props){
    const { control, ...rest } = props
    switch(control){
        case 'input':
            return <Input {...rest} />
        case 'textarea':
            return <Textarea height={props.height}{...rest} />
        case 'select':
            return <Select {...rest} />
        case 'radio':
            return <RadioButton {...rest} />
        case 'CheckboxGroup':
            return <CheckboxGroup {...rest} />
        case 'checkbox':
            return <Checkbox {...rest}/>
        default: return null
    }
}

export default BiztranControlsFormik
